import React from "react";
import userImg from "../../../resources/images/app/header/user.png";
import notificationImg from "../../../resources/images/app/header/notification.png";
import supportImg from "../../../resources/images/app/header/support.png";
import exitImg from "../../../resources/images/app/header/exit.png";
import walletImg from "../../../resources/images/app/header/wallet.png";
import HeaderDesktopInfoItem from "../desktop/HeaderDesktopInfoItem";
import HeaderDesktopActionItem from "../desktop/HeaderDesktopActionItem";
import NavigationMenuMobilePopupButton from "../mobile/NavigationMenuMobilePopupButton";
import MobileNavigationMenu from "../mobile/MobileNavigationMenu";
import HeaderNewsItemsPopup from "./news/HeaderNewsItemsPopup";
import "@theme-toggles/react/css/Classic.css";
import {Classic} from "@theme-toggles/react";

export default function PageHeaderView({
    balance,
    partnerName,
    isPartnerPage,
    isDesktop,
    isMobileVertical,
    displayEmail,
    isMobilePopupOpen,
    isNewsPopupOpen,
    notReadItemsAmount,
    numberOfUnreadMessages,
    news,
    onToggleMobilePopup,
    onToggleNewsPopup,
    onToggleChat,
    onToggleTheme,
    onLogout,
    onRedirectToFin,
    onRedirectToProfile,
    onReadNewsItem,
    onLoadMoreNews,
}) {
    const renderMobileNavigationMenu = () => {
        return <MobileNavigationMenu
            isOpen={isMobilePopupOpen}
            partnerName={partnerName}
        />;
    };

    const renderBalanceIcon = () => {
        return <HeaderDesktopInfoItem className="balance" img={walletImg} title={balance} onClick={onRedirectToFin}/>;
    };

    const renderProfileIcon = () => {
        return <HeaderDesktopInfoItem className="mail" img={userImg} title={partnerName} onClick={onRedirectToProfile}/>;
    };

    const renderNotificationsIcon = () => {
        return <HeaderDesktopActionItem
            img={notificationImg}
            imgClassName="notification-icon"
            onClick={onToggleNewsPopup}
            additionalEl={notReadItemsAmount > 0 && <div className="notyDot"/>}
        />;
    };

    const renderChatIcon = () => {
        return <HeaderDesktopActionItem
            img={supportImg}
            onClick={onToggleChat}
            additionalEl={numberOfUnreadMessages && <div className="notyDot"/>}
        />;
    };

    const renderThemeIcon = () => {
        return <div className="header-action-icon">
            <Classic reversed duration={750} onToggle={onToggleTheme}/>
        </div>;
    };

    const renderLogoutIcon = () => {
        return <HeaderDesktopActionItem img={exitImg} onClick={onLogout}/>;
    };

    return (
        <div className="header" id="page-header">
            {!isDesktop && renderMobileNavigationMenu()}

            <div className="info">
                {isPartnerPage && renderBalanceIcon()}
                {displayEmail && renderProfileIcon()}
            </div>

            <div className="nav-footer">
                {(!isMobilePopupOpen || !isMobileVertical) &&
                <div className="row nowrap">
                    {renderNotificationsIcon()}
                    {isPartnerPage && renderChatIcon()}
                </div>
                }
                {(isMobilePopupOpen || !isMobileVertical) &&
                <div className="row nowrap">
                    {renderThemeIcon()}
                    {renderLogoutIcon()}
                </div>
                }
            </div>

            {!displayEmail && <NavigationMenuMobilePopupButton onClick={onToggleMobilePopup}/>}

            {news && isNewsPopupOpen && (
                <HeaderNewsItemsPopup
                    news={news}
                    readNewsItem={onReadNewsItem}
                    notReadItemsAmount={notReadItemsAmount}
                    loadMoreNews={onLoadMoreNews}
                    onClose={onToggleNewsPopup}
                />
            )}
        </div>
    );
}
